// Photos a client attaches to a questionnaire item (a supplement label).
// Stored and shown to the care team exactly as uploaded: nothing reads,
// recognises or extracts from them (platform/docs/questionnaire-photos.md).
// The client re-encodes to JPEG with a 2048 px long edge before upload, so a
// real photo lands well under this; the cap only bounds abuse.
export const QUESTIONNAIRE_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const QUESTIONNAIRE_PHOTOS_PER_ITEM = 3;
/* The stored value of a `photo_upload` field: comma-separated photo ids.
   Whitespace and empty entries are dropped; validation (uuid, ownership,
   count, duplicates) is the store's job. */
export function parsePhotoIds(value) {
    return value
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
}
export function formatPhotoIds(ids) {
    return ids.join(",");
}
